export default __webpack_public_path__ + "static/media/logo_full.d28fb86e.png";